/**
 * Mask patient PII for display.
 * Search still works server-side on actual encrypted data.
 */

// "Amit Mehta" → "A*** M****"
export function maskName(name) {
  if (!name) return 'N/A';
  return name
    .split(' ')
    .map(part => part.length <= 1 ? part : part[0] + '*'.repeat(part.length - 1))
    .join(' ');
}

// "9876543210" → "98******10"
export function maskMobile(mobile) {
  if (!mobile) return '-';
  const s = String(mobile).replace(/\s/g, '');
  if (s.length <= 4) return '*'.repeat(s.length);
  return s.slice(0, 2) + '*'.repeat(s.length - 4) + s.slice(-2);
}

// "john.doe@example.com" → "j***.d**@e******.com"
export function maskEmail(email) {
  if (!email) return '-';
  const [local, domain] = email.split('@');
  if (!domain) return email[0] + '*'.repeat(email.length - 1);
  const maskedLocal = local.length <= 1 ? local : local[0] + '*'.repeat(local.length - 1);
  const [domainName, ...tld] = domain.split('.');
  const maskedDomain = domainName.length <= 1 ? domainName : domainName[0] + '*'.repeat(domainName.length - 1);
  return `${maskedLocal}@${maskedDomain}.${tld.join('.')}`;
}
